import Head from 'next/head';
import React from 'react';

const OG_TYPE = 'og:type';
const TWITTER_CARD = 'twitter:card';

const DEFAULT_TYPE_VALUE = 'website';
const DEFAULT_CARD_VALUE = 'summary';

type TypeHeadProps = {
  type?: string;
  card?: string;
};

/**
 *
 * @param {string} type - The type of page
 * @param {string} card - The type of card
 * @returns
 */
function TypeHead({ type = DEFAULT_TYPE_VALUE, card = DEFAULT_CARD_VALUE }: TypeHeadProps) {
  return (
    <Head>
      <meta property={OG_TYPE} content={type} key={OG_TYPE} />
      <meta property={TWITTER_CARD} content={card} key={TWITTER_CARD} />
    </Head>
  );
}

export default React.memo(TypeHead);
